module.exports = __webpack_public_path__ + "media/start.1f4848ab.wav";